module.exports = __webpack_public_path__ + "media/bootstrap-icons/envelope-open-fill-ccc68f53.svg";